<template>
  <v-list dense>
    <ul class="v-breadcrumbs pt-0 pb-2 px-4 theme--light">
      <template v-for="(item, idx) in breadcrumbs">
        <li class="v-breadcrumbs__divider" v-if="item.type === 'divider'" :key="`mbkbreadcrumb-${idx}`">/</li>
        <template v-else>
          <li v-if="breadcrumbsLen !== idx + 1" :key="`mbkbreadcrumb-${idx}`">
            <a href="#" class="v-breadcrumbs__item" @click="selectBreadcrumb(item, idx)">{{ item.text }}</a>
          </li>

          <li v-else :key="`mbkbreadcrumb-${idx}`">
            <span class="v-breadcrumbs__item">{{ item.text }}</span>
          </li>
        </template>
      </template>
    </ul>

    <v-list-item-group color="primary">
      <loader ref="loader" />

      <v-list-item v-for="item in items" :key="`mkb10-${item.id}`" @click="selectItem(item)">
        <v-list-item-content>
          <v-row no-gutters>
            <v-col cols="2">
              <span class="code">({{ item.code }})</span>
            </v-col>

            <v-col cols="10">
              <v-list-item-title class="text-wrap">{{ item.name }}</v-list-item-title>
            </v-col>
          </v-row>
        </v-list-item-content>
      </v-list-item>
    </v-list-item-group>
  </v-list>
</template>

<script>
import Loader from "@/components/Loader";
import { formModal } from "@/mixins/modal/form-modal.js";
export default {
  name: "SearchMKB10",

  components: { Loader },
  mixins: [formModal],
  props: {
    value: {},
    asModal: {
      type: Boolean,
      default: false,
    },
    needResetMKB10: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    breadcrumbs: [{ text: "Классы МКБ-10", id: 0, type: "item" }],
    items: [],
    parentModal: null,
  }),

  computed: {
    breadcrumbsLen() {
      return this.breadcrumbs.length;
    },
    parentModalClass() {
      return "";
    },
  },


  async mounted() {
    const parentModal = document.querySelector(".v-dialog.v-dialog--active");
    const observer = new MutationObserver(mutationRecords => {
      if (!parentModal.attributes.class.value.includes("active")) {
        this.reset();
      }
    });

    observer.observe(parentModal, { attributes: true, attributeFilter: ["class"] });

    this.items = await this.loadData();
  },

  methods: {
    async reset() {
      this.breadcrumbs = [{ text: "Классы МКБ-10", id: 0, type: "item" }];
      this.items = await this.loadData(0);
    },

    emit(data) {
      this.$emit("input", data);
      this.$emit("select", data);
      if (this.asModal) {
        this.$emit("close", data);
        this.$emit("submit", data);
        this.close();
      }
    },

    /**
     * @param {number} parentId
     * @return {Promise<Object[]>}
     */
    async loadData(parentId = 0) {
      let data = [];
      if (this.$refs.loader) {
        this.$refs.loader.show();

        try {
          const response = await this.$http.get(`v1/diseases`, {
            params: {
              parent_id: parentId,
            },
          });
          data = response.data.data;
        } catch (e) {
          console.error("ошибка", e.response.data.message);
        }

        this.$refs.loader.hide();
      }

      return data;
    },

    async selectBreadcrumb(item, idx) {
      this.breadcrumbs = this.breadcrumbs.slice(0, idx + 1);
      this.items = await this.loadData(item.id);
    },

    async selectItem(item) {
      const result = await this.loadData(item.id);

      if (result.length) {
        this.addBreadcrumbDivider();
        this.addBreadcrumbItem(item.id, item.code);
        this.items = result;
      } else {
        this.emit(item);
      }
    },

    /**
     * @param {number} id
     * @param {string} text
     * @return void
     */
    addBreadcrumbItem(id, text) {
      this.breadcrumbs.push({ id, text, type: "item" });
    },

    /**
     * @return void
     */
    addBreadcrumbDivider() {
      this.breadcrumbs.push({ text: "", id: "", type: "divider" });
    },
  },
};
</script>

<style scoped>
.code {
  color: #009999;
}
</style>
<style type="text/css">
.theme--light.v-breadcrumbs .v-breadcrumbs__divider,
.theme--light.v-breadcrumbs .v-breadcrumbs__item--disabled {
  color: rgba(0, 0, 0, 0.38);
}

.theme--dark.v-breadcrumbs .v-breadcrumbs__divider,
.theme--dark.v-breadcrumbs .v-breadcrumbs__item--disabled {
  color: rgba(255, 255, 255, 0.5);
}

.v-breadcrumbs {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  flex: 0 1 auto;
  list-style-type: none;
  margin: 0;
  padding: 18px 12px;
}
.v-breadcrumbs li {
  align-items: center;
  display: inline-flex;
  font-size: 14px;
}
.v-breadcrumbs li .v-icon {
  font-size: 16px;
}
.v-breadcrumbs li:nth-child(even) {
  padding: 0 12px;
}

.v-breadcrumbs__item {
  align-items: center;
  display: inline-flex;
  text-decoration: none;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}
.v-breadcrumbs__item--disabled {
  pointer-events: none;
}

.v-breadcrumbs--large li {
  font-size: 16px;
}
.v-breadcrumbs--large li .v-icon {
  font-size: 16px;
}
</style>
